var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"left"}},[_c('van-cell',{attrs:{"center":"","title":"分享时隐藏手机号"},scopedSlots:_vm._u([{key:"right-icon",fn:function(){return [_c('van-switch',{attrs:{"value":_vm.$store.state.user.shareHiddenInfo,"size":"24"},on:{"input":function($event){return _vm.onInput()}}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }